import React from 'react';

import {
  EmailMessageEnvironmentFilter,
  EmailMessageEventTypeFilter,
  type EmailMessagesFilterInput,
  EmailMessageTimePeriodFilter,
} from '@dashboard/generated/wp/platform';
import { Box, Button, Stack, Typography } from '@mui/material';

import BatchFilterChip from './TitleBarFilterChips/BatchFilterChip';
import EnvironmentFilterChip from './TitleBarFilterChips/EnvironmentFilterChip';
import EventTypeFilterChip from './TitleBarFilterChips/EventTypeFilterChip';
import SearchFieldFilterChip from './TitleBarFilterChips/SearchFieldFilterChip';
import TimePeriodFilterChip from './TitleBarFilterChips/TimePeriodFilterChip';

type Props = {
  filter: EmailMessagesFilterInput;
  emptyFilters: boolean;
  resetFilters: () => void;
  setFilter: (value: EmailMessagesFilterInput) => void;
};

export default function TableTitleBar({ filter, setFilter, resetFilters, emptyFilters }: Props) {
  let removeFiltersButton = null;
  if (!emptyFilters) {
    removeFiltersButton = (
      <Button size="small" onClick={resetFilters} color="secondary">
        Remove filters
      </Button>
    );
  }
  return (
    <Stack alignItems="center" direction="row" spacing={3}>
      <Typography variant="h6" component="h2" fontWeight="normal">
        Messages
      </Typography>
      <Box sx={{ display: { xs: 'none', md: 'block' } }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <EventTypeFilterChip
            value={filter.eventType}
            onDelete={() => setFilter({ eventType: EmailMessageEventTypeFilter.All })}
          />
          <EnvironmentFilterChip
            value={filter.environment}
            onDelete={() => setFilter({ environment: EmailMessageEnvironmentFilter.All })}
          />
          <TimePeriodFilterChip
            value={filter.timePeriod}
            onDelete={() => setFilter({ timePeriod: EmailMessageTimePeriodFilter.All })}
          />
          <SearchFieldFilterChip value={filter.query} onDelete={() => setFilter({ query: null })} />
          <BatchFilterChip
            value={filter.sourceEmailMessagesBatchId}
            onDelete={() => setFilter({ sourceEmailMessagesBatchId: null })}
          />
          {removeFiltersButton}
        </Stack>
      </Box>
    </Stack>
  );
}
